import React, { useState, useEffect } from "react";
import './index.scss';

export default function ShowSplash({onFinish})
 {
    return (
        <div className="splash-container">
            <video
                autoPlay
                muted
                playsInline
                onEnded={onFinish}
                className="splash-video"
            >
                <source src="/Images/splash.mp4" type="video/mp4" />
            </video>
      </div>
    )
}